export enum LOGS {
  LOGOUT = "LOGOUT",
  UNMOUNT = "UNMOUNT",
  SOCKET_DISCONNECT = "SOCKET_DISCONNECT",
}
